module.exports = __webpack_public_path__ + "static/img/7-active.1a2357ab.png";